// extracted by mini-css-extract-plugin
module.exports = {"container":"expandable-advantage-container-component_container__mpG3Z"};